import {
  brandCaptionLowerThird,
  BrandCaptionLowerThird,
  brandCaptionLowerThirdEntityId,
  BrandCaptionLowerThirdEntityId,
  brandEntityId,
  BrandEntityId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdUpdateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdUpdateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdUpdateRequest) {
    JsonSchemaValidator.validate(
      RoomBrandCaptionLowerThirdUpdateRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "captionId", "update"],
      properties: {
        roomId,
        brandId: brandEntityId,
        captionId: brandCaptionLowerThirdEntityId,
        update: brandCaptionLowerThird
      }
    };
  }
}

interface RoomBrandCaptionLowerThirdUpdateRequest {
  roomId: RoomId;
  brandId: BrandEntityId;
  captionId: BrandCaptionLowerThirdEntityId;
  update: BrandCaptionLowerThird;
}
